import React, { useState } from 'react';
import { subscribe } from '../api/strapiClient';

export default function Subscribe() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    setError(null);

    subscribe({ name, email })
      .then(() => {
        setStatus('success');
        setName('');
        setEmail('');
      })
      .catch((err) => {
        setStatus('error');
        setError(err.message || 'Unknown error');
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <main className="page">
      <section className="hero">
        <p className="hero__eyebrow">Stay informed</p>
        <h1 className="hero__title">Subscribe</h1>
        <p className="hero__subtitle">
          Get the day's top independent journalism delivered to your inbox every morning.
        </p>
      </section>

      <form className="subscribe-form" onSubmit={handleSubmit}>
        <label className="subscribe-form__field">
          <span className="subscribe-form__label">Name</span>
          <input
            type="text"
            className="subscribe-form__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>

        <label className="subscribe-form__field">
          <span className="subscribe-form__label">Email</span>
          <input
            type="email"
            className="subscribe-form__input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <button type="submit" className="subscribe-form__submit" disabled={submitting}>
          {submitting ? 'Subscribing…' : 'Subscribe'}
        </button>

        {status === 'success' && (
          <p className="subscribe-form__status">You're subscribed. Welcome to the wire.</p>
        )}
        {status === 'error' && (
          <p className="subscribe-form__status subscribe-form__status--error">
            Couldn't reach the newsroom. {error}
          </p>
        )}
      </form>
    </main>
  );
}
